import React from 'react';
import cn from 'classnames';

function RadialGradient({ className }: { className?: string }) {
    return <div className={cn('absolute -right-[125px] -top-[50px]  z-20 h-[150px] w-[200px] -rotate-6 rounded-[379px] bg-gradient-to-r  from-blue  to-transparent blur-[250px] sm:h-[329px] sm:w-[379px]', className)}></div>;
}

export default RadialGradient;
